import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=2bfdec8e&scoped=true"
import script from "./MessageBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBubble.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=2bfdec8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdec8e",
  null
  
)

export default component.exports